
import React from "react"
import { Box, Typography } from "@mui/material"

const TabNavigation = ({ tabs, activeTab, onTabChange }) => {
  return (
    <Box sx={{ display: "flex", gap: "32px" }}>
      {tabs.map((tab) => (
        <Box key={tab} sx={{ position: "relative" }}>
          <Typography
            onClick={() => onTabChange(tab)}
            sx={{
              color: activeTab === tab ? "#061522" : "#405261",
              textAlign: "center",
              fontFamily: "Inter",
              fontSize: "14px",
              fontWeight: activeTab === tab ? 500 : 400,
              lineHeight: "18px",
              cursor: "pointer",
              paddingBottom: "16px",
            }}
          >
            {tab}
          </Typography>
          {activeTab === tab && (
            <Box
              sx={{
                position: "absolute",
                bottom: "-1px",
                left: 0,
                right: 0,
                height: "2px",
                backgroundColor: "#148DFD",
                zIndex: 1,
              }}
            />
          )}
        </Box>
      ))}
    </Box>
  )
}

export default TabNavigation
